import { render, staticRenderFns } from "./ReporteSolicitudesNuevo.vue?vue&type=template&id=e981073a"
import script from "./ReporteSolicitudesNuevo.vue?vue&type=script&lang=js"
export * from "./ReporteSolicitudesNuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports